export default "__VITE_ASSET__f3ec1953__"